export interface IField {
  id?: string;
  name?: string;
  note?: string | null;
  IsDeleted?: boolean;
}

export const defaultValue: Readonly<IField> = {
  IsDeleted: false,
};
